export default "__VITE_ASSET__DZSsaSZw__"